import { Link } from "react-router";
import { appPaths } from "../../../shared/routing/appPaths";
import { parseContentAddress } from "../../../shared/references/contentReferences";
import { useDocumentName } from "../../sources/document/useSourceDocument";

/** Resolve the name at the pinned version, including the segment's full path. */
export default function ThreadSubjectLink({ subject, link = true }: { subject: string; link?: boolean }) {
  const address = parseContentAddress(subject);
  const version = address?.document.version ?? null;
  const name = useDocumentName(address === null || version === null ? null : { documentId: address.document.documentId, version });
  if (address === null) return null;
  const label = version === null ? subject : name ?? address.document.documentId;
  const text = <>{label}{address.segmentPath === null ? "" : ` #${address.segmentPath}`}</>;
  return link ? <Link className="app-link app-link-cue-away block text-sm" to={appPaths.sourceDocument(address.document, address.segmentPath)}>{text}</Link> : <span className="app-text-muted block truncate text-xs" title={subject}>{text}</span>;
}
